import { render, staticRenderFns } from "./ControlFrecuencia.vue?vue&type=template&id=39cab76d&scoped=true&"
import script from "./ControlFrecuencia.vue?vue&type=script&lang=js&"
export * from "./ControlFrecuencia.vue?vue&type=script&lang=js&"
import style0 from "./ControlFrecuencia.vue?vue&type=style&index=0&id=39cab76d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39cab76d",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
installComponents(component, {VBtn})
